import { render, staticRenderFns } from "./GosMoney.vue?vue&type=template&id=5973f076"
import script from "./GosMoney.vue?vue&type=script&lang=js"
export * from "./GosMoney.vue?vue&type=script&lang=js"
import style0 from "./GosMoney.vue?vue&type=style&index=0&id=5973f076&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports